import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import '../../services/GlobalVariables';

const USERS_API_URL = global.SET_API_URL + 'users/';

const initialState = {
    users: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ''
};

export const getUsersList = createAsyncThunk('userManagement/getUsersList', async (_, thunkAPI) => {
    try {
        const result = await axios.get(USERS_API_URL + 'getUsersList');
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

export const createUser = createAsyncThunk('userManagement/createUser', async (payload, thunkAPI) => {
    try {
        const result = await axios.post(USERS_API_URL + 'addNewUser', payload);
        return result.data;
    } catch (error) {
        const message = (error.response && error.response.data && (error.response.data.message || error.response.data.error)) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
    }
});

const userManagementSlice = createSlice({
    name: 'userManagement',
    initialState,
    reducers: {
        resetUserManagementState: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsersList.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
                state.message = '';
            })
            .addCase(getUsersList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.users = action.payload || [];
            })
            .addCase(getUsersList.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
                state.users = [];
            })
            .addCase(createUser.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
                state.isSuccess = false;
                state.message = '';
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.message = action.payload?.message || 'User created successfully.';
            })
            .addCase(createUser.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    }
});

export const { resetUserManagementState } = userManagementSlice.actions;

export default userManagementSlice.reducer;